<template>
  <div class="stat-cards">
    <el-card class="card-item" shadow="hover">
      <div class="card-content">
        <div class="card-info">
          <p class="card-value">{{ form.totalWorkHours }} 小时</p>
          <p class="card-label">总工时</p>
        </div>
        <div class="card-trend">
          <!-- <i class="el-icon-arrow-up"></i> 5% -->
        </div>
      </div>
    </el-card>
    <el-card class="card-item" shadow="hover">
      <div class="card-content">
        <p class="card-value">{{ form.taskCompletionRate }} %</p>
        <p class="card-label">任务完成率</p>
      </div>
      <div class="card-trend">
        <!-- <i class="el-icon-arrow-down"></i> 2% -->
      </div>
    </el-card>
    <el-card class="card-item" shadow="hover">
      <div class="card-content">
        <p class="card-value">{{ form.averageWorkOrdersPerPerson }} 个/人</p>
        <p class="card-label">人均工作量</p>
      </div>
      <div class="card-trend">
        <!-- <i class="el-icon-arrow-up"></i> 8% -->
      </div>
    </el-card>
    <el-card class="card-item" shadow="hover">
      <div class="card-content">
        <p class="card-value">{{form.abnormalWorkOrders}}人</p>
        <p class="card-label">异常预警</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getallStaffEfficiency } from "../api";
export default {
  name: 'StatCards',
  inject: ['parentThat'],
  data () {
    return {
        form:{}
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const { queryForm } = this.parentThat
      getallStaffEfficiency(queryForm).then(({ data }) => {
        this.form =data.data
      })
    }
  }

}
</script>

<style scoped>
.stat-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.card-item {
  width: 23%;
}
.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-value {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
}
.card-label {
  font-size: 14px;
  color: #666;
}
.card-trend {
  display: flex;
  align-items: center;
  color: green;
}
.card-trend .el-icon-arrow-down {
  color: red;
}
</style>